export const INVITATION_NOT_SENT = "Invitation Not Sent";
export const SENDING_INVITATION_STATUS = "Sending Invitation";
export const SENDING_INVITATION_FAILED = "Sending invitation failed";
export const GRID_DATA_QUERY_PREFIX = "user-management-grid-data-query";
export const PAGE_SIZE = 100;
export const ROW_HEIGHT = 85;
export const COLUMN_WIDTH = 196;
export const SELECT_ALL = "SELECT_ALL";
export const INDETERMINATE = "indeterminate" as unknown as boolean;
export const BLANK_VALUE = "_blank_";
export const FILTER_DEBOUNCE_TIMER = 400;
